"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.eventTypes.conversation_analysis': 'Analisi Conversazione',
    'webhook.eventTypes.avatar_updated': 'Avatar Aggiornato',
    'webhook.eventTypes.avatar_deleted': 'Avatar Eliminato',
    'webhook.eventTypes.avatar_test_complete': 'Test Avatar Completato',
    'webhook.eventTypes.knowledge_added': 'Conoscenza Aggiunta',
    'webhook.eventTypes.knowledge_removed': 'Conoscenza Rimossa',
    'webhook.eventTypes.knowledge_notify': 'Modifica Conoscenza',
};
